/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LeadComment } from './LeadComment';
import {
    LeadCommentFromJSON,
    LeadCommentFromJSONTyped,
    LeadCommentToJSON,
} from './LeadComment';

/**
 * 
 * @export
 * @interface CreateLeadComment201Response
 */
export interface CreateLeadComment201Response {
    /**
     * 
     * @type {LeadComment}
     * @memberof CreateLeadComment201Response
     */
    data?: LeadComment;
}

/**
 * Check if a given object implements the CreateLeadComment201Response interface.
 */
export function instanceOfCreateLeadComment201Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateLeadComment201ResponseFromJSON(json: any): CreateLeadComment201Response {
    return CreateLeadComment201ResponseFromJSONTyped(json, false);
}

export function CreateLeadComment201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLeadComment201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : LeadCommentFromJSON(json['data']),
    };
}

export function CreateLeadComment201ResponseToJSON(value?: CreateLeadComment201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': LeadCommentToJSON(value.data),
    };
}

